//import hook react
import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom'

//import hook useHitory from react router dom
import { useHistory } from 'react-router';

//import axios
import axios from 'axios';

function Callback() {
    const [response, setResponse] = useState("");
    const history = useHistory();

    //function "fetchData"
    const fetchData = async () => {
        const urlParams = new URLSearchParams(window.location.search);
        let code = urlParams.get('code');

        const state = localStorage.getItem('state');
        const formData = new URLSearchParams();
        formData.append('grant_type', 'authorization_code');
        formData.append('client_id', process.env.REACT_APP_CLIENT_ID);
        formData.append('client_secret', process.env.REACT_APP_CLIENT_SECRET);
        formData.append('redirect_uri', process.env.REACT_APP_WEB_URL + '/callback');
        formData.append('code', code);
        console.log('code', code);

        await axios.post(process.env.REACT_APP_API_URL + '/oauth/token', formData)
            .then((response) => {
                setResponse(response.data.access_token);

                //set token on localStorage
                localStorage.setItem(process.env.REACT_APP_TOKEN_NAME, response.data.access_token);
                history.push('/dashboard');

            })
            .catch((error) => {
                history.push('/');
                console.log(error);
            })
    }

    //hook useEffect
    useEffect(() => {
        fetchData();
    }, []);
}

export default Callback;
